import { Injectable } from '@angular/core';

import { Attribute } from '@shared/models/attribute';
import { ItemAttributeAssignment } from '@shared/models/item-attribute-assignment';
import { LopAttributeAssignment } from '@shared/models/lop-attribute-assignment';
import { StatusType } from '@shared/models/status-type';
import { InspectionAttributeAssignment } from '@inspections/models/inspection-attribute-assignment';

type AttributeAssignment =
  | LopAttributeAssignment
  | ItemAttributeAssignment
  | InspectionAttributeAssignment;

@Injectable()
export class AttributeFilteringService {
  filterByActiveOrUsedAttributes<
    T extends Attribute,
    U extends AttributeAssignment
  >(attributes: T[], assignments: U[]): T[] {
    if (!attributes?.length) {
      return [];
    }

    if (!assignments?.length) {
      return attributes.filter(
        attr => !attr.isDeleted && attr.status === StatusType.Active
      );
    }

    return attributes.filter(
      attr =>
        (!attr.isDeleted && attr.status === StatusType.Active) ||
        assignments.some(assign => assign.attributeId === attr.id)
    );
  }
}
